import { NumberInput } from '@angular/cdk/coercion';
import { NzUploadFile } from 'ng-zorro-antd/upload';

export class Announce{
    id : number;
    title : string;
    announceType : number;
    startDate: Date;
    expirationDate: Date;
    fromEadId: number;
    isCustom : boolean;
    content : string; 
    listAttachment : number[];
    listStaff: number[];
    listCoso: number[];
    listDVQL: number[];
} 
export class Attachment{
    fileId : number;
    fileName : string;
    filePath : string;
}
